// Channel data actions
export const SET_CHANNELS = 'channel/SET_CHANNELS';
export const SET_ALL_CHANNELS = 'channel/SET_ALL_CHANNELS';
export const UPDATE_CHANNEL = 'channel/UPDATE_CHANNEL';

// UI state actions
export const SET_ARCHIVE_FILTER = 'channel/SET_ARCHIVE_FILTER';
export const SET_SHOW_UNLINKED_COUNT = 'channel/SET_SHOW_UNLINKED_COUNT';
export const SET_CHANNEL_PANEL_OPEN = 'channel/SET_CHANNEL_PANEL_OPEN';
export const SET_FULLSCREEN_IMAGE = 'channel/SET_FULLSCREEN_IMAGE';
export const SET_ACTIVE_THREAD_PARENT_ID = 'channel/SET_ACTIVE_THREAD_PARENT_ID';

// Loading states
export const SET_CHANNELS_LOADING = 'channel/SET_CHANNELS_LOADING';
